import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/advertisement-banner';

Component('tr-advertisement-banner', {
  mixins: [eventListenerMixin],

  properties: {
    key: String,
    url: String,
  },

  ready() {
    this.listenTo(this, 'click', this.handleClick.bind(this));
  },

  handleClick(event) {
    const { target } = event;
    if (closest(target, '.twr-resource-del')) {
      this.removeBanner();
      return;
    }

    if (this.url) window.open(this.url);
  },

  removeBanner() {
    this.remove();

    if (this.key) {
      $.post('/new_feature_confirmations', {
        metadata_key: this.key,
        metadata_value: false,
      });
    }
  },

  disconnected() {
    this.stopListening();
  },
});
